import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        form: '=',
        context: '=',
        canManageCourse: '<',
        trainingForm: '=',
        key: '<',
        trainingTypes: '<',
        hasPlanningGroups: '<',
        ckconfig: '<',
        isDisabled: '<',
        course: '<'
    },
    template: `
        <div class="mt20">
            <file-file-manager
                entity-type="'course_training'"
                entity-id="vm.trainingForm.id"
                course-id="vm.course.id">
            </file-file-manager>
        </div>
        <div class="mt20">
            <div class="heading01">
                <h3>{{ 'training.External learning content' | translate }}</h3>
            </div>
            <form-row error="vm.form.errors.courseTrainings[vm.key].externalMaterialUrl">
                <label class="label">{{ 'training.URL' | translate }}</label>
                <div class="items">
                    <input ng-disabled="vm.isDisabled"
                        type="text" ng-model="vm.trainingForm.externalMaterialUrl" class="form-control">
                    <form-row-error></form-row-error>
                </div>
            </form-row>
            <form-row error="vm.form.errors.courseTrainings[vm.key].externalMaterialLinkTitle">
                <label class="label">{{ 'training.Title' | translate }}</label>
                <div class="items">
                    <input ng-disabled="vm.isDisabled"
                        type="text" ng-model="vm.trainingForm.externalMaterialLinkTitle" class="form-control">
                    <form-row-error></form-row-error>
                </div>
            </form-row>
        </div>
        <br />
        <div class="heading01">
            <h3>{{ 'courses.Learning materials' | translate }}</h3>
        </div>
        <form-row error="vm.form.errors.courseTrainings[vm.key].learndashCourseId">
            <label class="label">{{ 'courses.Learning materials' | translate }}</label>
            <div class="items">
                <select ng-disabled="vm.isDisabled" class="form-control"
                    ng-model="vm.trainingForm.learndashCourseId"
                    ng-change="vm.CourseVersionTrainingFormLearndashService.getLearndashCourse(vm.trainingForm)"
                    ng-options="course.ID as course.post_title for course in vm.CourseVersionTrainingFormLearndashService.learndashCourses">
                    <option value=""></option>
                </select>
                <p class="desc warn" ng-if="!vm.CourseVersionTrainingFormLearndashService.hasAccessToLdStudyMaterials(vm.trainingForm.learndashCourseId)">
                    {{ 'courses.Saved value is not displayed. You do not have access to the attached material' | translate }}
                </p>
                <a
                    class="btn edit"
                    ng-if="vm.canManageCourse
                     && vm.PrivilegeService.canManageMaterials()
                     && vm.trainingForm.canEditLearndashCourse
                     && vm.CourseVersionTrainingFormLearndashService.showLearndashCourseEditLink
                     && vm.CourseVersionTrainingFormLearndashService.hasAccessToLdStudyMaterials(vm.trainingForm.learndashCourseId)"
                    ng-click="vm.CourseVersionTrainingFormLearndashService.editLdMaterial(vm.trainingForm)"
                >
                    {{ 'courses.Edit study material' | translate }}
                </a>
            </div>
        </form-row>
    `
})

export default class {
    constructor (TokenService, CourseVersionService, PrivilegeService, CourseVersionTrainingFormService,
                 CourseVersionTrainingFormLearndashService, CourseVersionTrainingFormFileService, COURSE_TRAINING_TYPE_ENUM,
                 COURSE_TRAINING_PASSING_TYPE_ENUM, $translate) {
        this.TokenService = TokenService;
        this.CourseVersionService = CourseVersionService;
        this.PrivilegeService = PrivilegeService;
        this.CourseVersionTrainingFormService = CourseVersionTrainingFormService;
        this.CourseVersionTrainingFormLearndashService = CourseVersionTrainingFormLearndashService;
        this.CourseVersionTrainingFormFileService = CourseVersionTrainingFormFileService;
        this.COURSE_TRAINING_TYPE_ENUM = COURSE_TRAINING_TYPE_ENUM;
        this.COURSE_TRAINING_PASSING_TYPE_ENUM = COURSE_TRAINING_PASSING_TYPE_ENUM;
        this.defaultLanguage = TokenService.getCompanyLanguage();
        this.$translate = $translate;
    }

    $onInit () {
        // get the course in order to assign showLearndashCourseEditLink the right way
        this.CourseVersionTrainingFormLearndashService.getLearndashCourse(this.trainingForm);

        this.tooltipTexts = {
            passingType: this.$translate.instant('courses.Training passing type tooltip'),
            description: this.$translate.instant('courses.Training description tooltip')
        };
    }
}



// WEBPACK FOOTER //
// ./src/app/components/courses/courses/steps/version/training/additional/classroom/index.js